import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthenticationService } from '../services';
import { environment } from 'src/environments/environment';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthenticationService);
    const token = authService.tokenValue;
    const isApiUrl = req.url.startsWith(environment.apiUrl);

    if (token && isApiUrl) {
        req = req.clone({
            setHeaders: {
                authorization: `Token ${token.token}`
            }
        });
    }

    return next(req);
};
